import { render, staticRenderFns } from "./PostModalOffer.vue?vue&type=template&id=1706c6f2&scoped=true&"
import script from "./PostModalOffer.vue?vue&type=script&lang=js&"
export * from "./PostModalOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706c6f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1706c6f2')) {
      api.createRecord('1706c6f2', component.options)
    } else {
      api.reload('1706c6f2', component.options)
    }
    module.hot.accept("./PostModalOffer.vue?vue&type=template&id=1706c6f2&scoped=true&", function () {
      api.rerender('1706c6f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Offers/PostModalOffer.vue"
export default component.exports